// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_status_container__EyYoG {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 14px;
  font-weight: 500;
}

.styles_status_dot__J6JTf {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.styles_ativo__kaHlT {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.styles_ativo__kaHlT .styles_status_dot__J6JTf {
  background-color: #4caf50;
}

.styles_bloqueado__Ldpn3 {
  background-color: #fff3e0;
  color: #f57c00;
}

.styles_bloqueado__Ldpn3 .styles_status_dot__J6JTf {
  background-color: #ff9800;
}

.styles_inativo__zI8E6 {
  background-color: #fce4ec;
  color: #c2185b;
}

.styles_inativo__zI8E6 .styles_status_dot__J6JTf {
  background-color: #e91e63;
}


`, "",{"version":3,"sources":["webpack://./src/pages/ContaCorrente/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".status_container {\n  align-items: center;\n  display: inline-flex;\n  gap: 8px;\n  padding: 5px 12px;\n  border-radius: 15px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.status_dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.ativo {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.ativo .status_dot {\n  background-color: #4caf50;\n}\n\n.bloqueado {\n  background-color: #fff3e0;\n  color: #f57c00;\n}\n\n.bloqueado .status_dot {\n  background-color: #ff9800;\n}\n\n.inativo {\n  background-color: #fce4ec;\n  color: #c2185b;\n}\n\n.inativo .status_dot {\n  background-color: #e91e63;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status_container": `styles_status_container__EyYoG`,
	"status_dot": `styles_status_dot__J6JTf`,
	"ativo": `styles_ativo__kaHlT`,
	"bloqueado": `styles_bloqueado__Ldpn3`,
	"inativo": `styles_inativo__zI8E6`
};
export default ___CSS_LOADER_EXPORT___;
